import { render, staticRenderFns } from "./NoGroups.vue?vue&type=template&id=07a6e56b&"
import script from "./NoGroups.vue?vue&type=script&lang=js&"
export * from "./NoGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports